// src/components/sections/AboutSection.jsx
import React from "react";
import { useTranslation } from "react-i18next";

import targetPng from "../../assets/icon/Target.png";
import rocketPng from "../../assets/icon/Vision.png";
import handshakePng from "../../assets/icon/Value.png";
import InfoCard from "../common/InfoCard";

export default function AboutSection() {
  const { t, i18n } = useTranslation();
  const isEN = i18n.language === "en";

  return (
    <section id="about" className="relative isolate">
      <div className="flex flex-col gap-[48px] bg-[linear-gradient(to_right,white_40%,#B1D1F7CC_70%,#E6F0FC_100%)] px-4 py-36 tabletair:py-16 tabletmini:py-16 mobile:py-10">
        <div className="flex flex-col gap-[16px] max-w-[1400px] mx-auto mobile:px-4 tabletpro:px-10 tabletair:px-10 tabletmini:px-10 ">
          {/* Caption */}
          <p className="text-center text-[20px] mobile:text-[14px] font-medium text-brandBlue-500">
            {t("about.caption", { defaultValue: "GIỚI THIỆU" })}
          </p>

          <div
            className="flex flex-col font-semibold text-center font-500 text-brandBlue-900
                 text-[56px] mobile:text-[24px] tabletpro:text-[56px] tabletair:text-[36px] tabletmini:text-[32px]"
          >
            {t("about.headline1", {
              defaultValue: "Một nền tảng – Mọi kết nối tin cậy giữa",
            })}

            {/* chỉ chèn dòng trống nếu không phải tiếng Anh */}
            {!isEN && <div className="h-2" />}

            {t("about.headline2", {
              defaultValue: "Chính phủ và Doanh nghiệp",
            })}
          </div>

          {/* Sub */}
          <p className="mx-auto max-w-[1140px] font-normal text-[16px] text-center text-neutral-10 mobile:text-[16px] tabletpro:text-[16px] tabletair:text-[16px] tabletmini:text-[16px]">
            {t("about.sub", {
              defaultValue:
                "Quantera là nền tảng kết nối chính phủ và doanh nghiệp thông qua công nghệ blockchain tiên tiến, bảo mật, tự chủ và đạt chuẩn quốc tế. Nhằm đảm bảo Xác thực danh tính số An toàn, Minh bạch, Chống gian lận trên không gian mạng và bảo vệ quyền riêng tư của người sử dụng",
            })}
          </p>
        </div>

        <div className="grid grid-cols-3 tabletair:grid-cols-1 tabletmini:grid-cols-1 mobile:grid-cols-1 gap-6 md:gap-8 max-w-[1400px] mx-auto mobile:px-4 tabletpro:px-10 tabletair:px-10 tabletmini:px-10">
          {/* Sứ mệnh */}
          <InfoCard
            title={t("about.cards.mission.mission", {
              defaultValue: "Sứ mệnh",
            })}
            icon={targetPng}
            iconClass="md:bottom-4 md:right-5"
          >
             <p>
              {t("about.cards.mission.text", {
                defaultValue:
                  "Xây dựng nền tảng blockchain tin cậy, giúp các tổ chức, doanh nghiệp và chính phủ:",
              })}
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                {t("about.cards.mission.li1", {
                  defaultValue: "Quản lý danh tính số tự chủ (SSI)",
                })}
              </li>
              <li>
                {t("about.cards.mission.li2", {
                  defaultValue:
                    "Triển khai ký số điện tử có giá trị pháp lý cao (QES)",
                })}
              </li>
              <li>
                {t("about.cards.mission.li3", {
                  defaultValue: "Cấp phát & xác minh chứng thư điện tử (VC)",
                })}
              </li>
              <li>
                {t("about.cards.mission.li4", {
                  defaultValue: "Phát triển ví điện tử danh tính số an toàn",
                })}
              </li>
            </ul>
          </InfoCard>

          {/* Tầm nhìn */}
          <InfoCard
            title={t("about.cards.vision.title", {
              defaultValue: "Tầm nhìn",
            })}
            icon={rocketPng}
            iconClass="md:bottom-3 md:right-6"
          >
            <p>
              {t("about.cards.vision.text", {
                defaultValue:
                  "Trở thành nền tảng hạ tầng số cốt lõi hàng đầu tại Việt Nam và khu vực Đông Nam Á trong lĩnh vực danh tính số, ký số điện tử, đáp ứng các tiêu chuẩn quốc tế.",
              })}
            </p>
          </InfoCard>

          {/* Giá trị cốt lõi */}
          <InfoCard
            title={t("about.cards.values.title", {
              defaultValue: "Giá trị cốt lõi",
            })}
            icon={handshakePng}
            iconClass="md:bottom-2 md:right-6"
          >
            <ul className="list-disc pl-5 space-y-2">
              <li>
                {t("about.cards.values.li1", {
                  defaultValue: "Tự chủ công nghệ",
                })}
              </li>
              <li>
                {t("about.cards.values.li2", {
                  defaultValue: "An toàn dữ liệu",
                })}
              </li>
              <li>
                {t("about.cards.values.li3", {
                  defaultValue: "Bảo mật tối đa",
                })}
              </li>
              <li>
                {t("about.cards.values.li4", {
                  defaultValue: "Khả năng mở rộng cao",
                })}
              </li>
              <li>
                {t("about.cards.values.li5", {
                  defaultValue:
                    "Tương thích tiêu chuẩn quốc tế (EBSI, eIDAS, EUDI Wallet)",
                })}
              </li>
            </ul>
          </InfoCard>
        </div>
      </div>
    </section>
  );
}
